import WebPageLayout from "../../../../layouts/WebPageLayout";
import Table from "../../../../components/Table";
import {GetWorkOrderScreenHeader} from "../work-order-screen-headers";
import {
  useGetWorkOrderLabourQuery,
  useGetWorkOrderQuery
} from "../../../../../../store/services/api/work-order-api";
import {Button as AntButton, Flex} from "antd";
import {useSetLoading} from "../../../../../../hooks/useSetLoading";
import React, {useState} from "react";
import {ScreenProps} from "../../../../../../utils/screen-props-helper";
import {WorkOrdersStackParamList} from "../../WorkOrdersStack";
import {WorkOrderLabour} from "../../../../../../store/data/entities/work-order-labour";
import {Button} from "react-native-paper";
import {WorkOrderStatus} from "../../../../../../store/data/entities/work-order";
import AddWorkOrderLabourModal from "../../../../../technician-v2/modals/AddWorkOrderLabourModal";
import {DateTime} from "luxon";
import {humanizeDate, humanizeTime} from "../../../../../../utils/humanizers";
import {FileOutlined, EditOutlined, EyeOutlined} from "@ant-design/icons";
import useUser from "../../../../../../hooks/useUser";

export default function WorkOrderLabourScreen({route}: ScreenProps<WorkOrdersStackParamList, 'labour'>) {
  const workOrderId = route?.params?.id;
  const {data: workOrder, isFetching: workOrderFetching} = useGetWorkOrderQuery({
    id: workOrderId
  }, {
    skip: !workOrderId,
  });
  const {data, isFetching} = useGetWorkOrderLabourQuery(workOrderId, {
    skip: !workOrderId,
  });
  const [labourModalVisible, setLabourModalVisible] = useState(false);
  useSetLoading([isFetching || workOrderFetching]);

  const openWorkLabourEditModal = (item: WorkOrderLabour) => {
      setSelectedWorkOrderLabour(item);
      setLabourModalVisible(true);
    }

  const [selectedWorkOrderLabour, setSelectedWorkOrderLabour] = useState<WorkOrderLabour | undefined>(undefined);
  const {user} = useUser();
    const canEdit = user.role === 'Admin';
    
  const canAdd = user.role === 'Admin' ||
    workOrder?.status === WorkOrderStatus.Approved
    || workOrder?.status === WorkOrderStatus.Completed
    || workOrder?.status === WorkOrderStatus.InProgress;

    

  const totalHours = (data ?? []).reduce(
    (sum, row) => sum + (row.hoursWorked ?? 0),
    0
  );

  const extendedData = [
    ...(data ?? []),
    { id: "total-row", isSummary: true, hoursWorked: totalHours } as WorkOrderLabour & { isSummary: boolean }
  ];

  return (
    <>
      <WebPageLayout header={GetWorkOrderScreenHeader(workOrderId)}>
        <Table<WorkOrderLabour & { isSummary?: boolean }>
          keyExtractor={(item, index) =>
            item.isSummary ? "wo-labour-total" : `wo-labour-${index}`
          }
          data={extendedData}
          columns={[
            {
              title: "Date",
              key: "date",
              render: item =>
                item.isSummary ? (
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  <strong>Total Hours</strong>
                </div>                  
                ) : (
                  humanizeDate(item.date)
                )
            },
            { title: "Technician", key: "user", render: item => (item.isSummary ? "" : item.user) },
            { title: "Start Time", key: "startDateTime", render: item => (item.isSummary ? "" : humanizeTime(item.startDateTime)) },
            {
              title: "End Time",
              key: "endDateTime",
              render: item =>
                item.isSummary
                  ? ""
                  : item.endDateTime
                  ? humanizeTime(item.endDateTime)
                  : ""
            },
            {
              title: "Hours",
              key: "hoursWorked",
              render: item =>
              item.isSummary ? (
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {item.hoursWorked}
                </div>
              ) : (
                item.hoursWorked
              )
            },
            {
              title: "Edit",
              render: (item) => {
                if (item.isSummary) {
                  return null; 
                }
                return (
                  <Flex gap={4}>
                    <AntButton
                      disabled={!canEdit}
                      onClick={() => openWorkLabourEditModal(item)}
                      icon={<EditOutlined />}
                    >
                      Edit
                    </AntButton>
                  </Flex>
                )
              }
            }
          ]}
        />

        <Button
          disabled={!canAdd}
          style={{marginTop: 12}}
          icon='plus'
          mode="elevated"
          onPress={() => setLabourModalVisible(true)}
          buttonColor='#fff'
          textColor='#0f0f0f'
        >
          Add Labour
        </Button>
      </WebPageLayout>

      <AddWorkOrderLabourModal
        workOrderId={workOrderId}
        onClose={() => {
          setLabourModalVisible(false);
          setSelectedWorkOrderLabour(undefined);
        }}
        visible={labourModalVisible}
        labour={selectedWorkOrderLabour} 
      />
    </>
  )
}
